// lib/placeholder.js — Real images via Unsplash + SVG gradient fallback
//
// Preferred: unsplash(photoId, w, h) — real photos, CORS-safe, free
// Fallback:  placeholder(w, h, emoji, from, to) — inline SVG, no network

// Unsplash image URL (uses ixlib resizing CDN — fast, CORS-safe, free)
export function unsplash(id, w = 400, h = 300) {
  return 'https://images.unsplash.com/photo-' + id + '?w=' + w + '&h=' + h + '&fit=crop&auto=format';
}

// SVG gradient placeholder (no external requests — works offline)
export function placeholder(w = 400, h = 300, emoji = '📷', from = '#6366f1', to = '#8b5cf6') {
  return `data:image/svg+xml,${encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '">' +
    '<defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">' +
    '<stop offset="0%" stop-color="' + from + '"/>' +
    '<stop offset="100%" stop-color="' + to + '"/>' +
    '</linearGradient></defs>' +
    '<rect width="' + w + '" height="' + h + '" fill="url(#g)"/>' +
    '<text x="' + (w/2) + '" y="' + (h/2 + Math.min(w,h)*0.09) + '" font-size="' + (Math.min(w,h)*0.25) + '" text-anchor="middle">' + emoji + '</text>' +
    '</svg>'
  )}`;
}